import React from 'react';
import { useSelector } from 'react-redux'
import { START } from 'pu-data/QuoteSteps'
import PriceVendor from './price_vendor/PriceVendor';

const VendorPrices = () => {
  const {
    usGroups,
    usCombined,
    quoteStep,
  } = useSelector((state) => state.fabrication)
  if (!usGroups) return null;

  if (quoteStep === START) return null;

  if (!isManager) return null;

  return (
    <div className="card mb-4">
      <div className="card-body vendor-groups">
        {usGroups.map((group, key) => (
          <PriceVendor
            key={key}
            quoteStep={quoteStep}
            usCombined={usCombined}
            group={group} />
        ))}
      </div>
    </div>);
};

export default VendorPrices;
